import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getCategoryDetail, getSolutions } from '../api';
import './IndustryListPage.css';

export default function SolutionListPage() {
  const { categoryId } = useParams();
  const [solutions, setSolutions] = useState([]);
  const [category, setCategory] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cid = parseInt(categoryId);
        // 获取分类详情（含子分类 + 方案列表）
        if (!isNaN(cid)) {
          const detail = await getCategoryDetail(cid);
          setCategory(detail);
          setSubCategories(detail.children || []);
          setSolutions(detail.solutions || []);
        }

        // 同时从 solutions API 获取完整列表（含分页）
        const result = await getSolutions({ categoryId: cid, pageSize: 50 });
        if (result && result.list && result.list.length > 0) {
          setSolutions(result.list);
        }
      } catch (e) {
        console.error('方案列表加载失败:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [categoryId]);

  const categoryName = category?.name || '行业方案';
  const bannerBg = category?.banner_image
    ? { background: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url(${category.banner_image}) center/cover` }
    : { background: 'linear-gradient(135deg,#1a56db,#0d3a8e)' };

  return (
    <>
      <Helmet>
        <title>{category?.seo_title || `${categoryName} - 行业方案`} - 河南和正网络科技有限公司</title>
        <meta name="description" content={category?.seo_description || category?.description || `${categoryName}行业解决方案`} />
        {category?.seo_keywords && <meta name="keywords" content={category.seo_keywords} />}
      </Helmet>

      <div className="page-banner" style={bannerBg}>
        <div className="container">
          <h1>{categoryName}</h1>
          <nav className="breadcrumb">
            <Link to="/">首页</Link> <span>›</span>
            <span>行业方案</span> <span>›</span>
            <span>{categoryName}</span>
          </nav>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {/* 子分类导航 */}
          {subCategories.length > 0 && (
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 30 }}>
              {subCategories.map(sc => (
                <Link
                  key={sc.id}
                  to={`/category/${sc.id}`}
                  style={{
                    padding: '8px 20px', borderRadius: 20, fontSize: 14,
                    background: 'var(--bg-secondary)', color: 'var(--text-primary)',
                    textDecoration: 'none', border: '1px solid var(--border)',
                    transition: 'all .2s'
                  }}
                >
                  {sc.name}
                  {sc.solution_count > 0 && (
                    <span style={{ marginLeft: 6, fontSize: 12, color: 'var(--primary)', fontWeight: 600 }}>
                      {sc.solution_count}
                    </span>
                  )}
                </Link>
              ))}
            </div>
          )}

          {loading ? (
            <div className="product-grid">
              {[1,2,3,4,5,6].map(i => <div key={i} className="skeleton-card product-skeleton" />)}
            </div>
          ) : solutions.length === 0 ? (
            <div className="empty-state">
              <p style={{fontSize:16,marginBottom:12}}>该分类下暂无方案</p>
              <p>联系我们获取定制化解决方案</p>
            </div>
          ) : (
            <div className="product-grid">
              {solutions.map(s => (
                <Link key={s.id} to={`/solution/${s.id}`} className="product-card">
                  <div className="product-cover">
                    {s.cover_image
                      ? <img src={s.cover_image} alt={s.name} loading="lazy" />
                      : <div className="cover-placeholder">SOLUTION</div>
                    }
                  </div>
                  <div className="product-body">
                    <h3>{s.name}</h3>
                    <p>{s.summary || '点击查看详细方案介绍'}</p>
                    <span className="btn btn-outline btn-sm" style={{alignSelf:'flex-start'}}>查看详情</span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
